import {
  getDaysInMonth,
  format,
  isSameDay,
  parse,
} from 'date-fns';
import hourConvert from 'hour-convert';
import {
  padStart,
  omitBy,
} from 'lodash';
import ms from 'ms';

export const ADULT_AGE = 21;
export const MIN_AGE = 18;

// javascript date months are by index, starting at 0
/* eslint-disable quote-props */
export const months = {
  '0': 'January',
  '1': 'February',
  '2': 'March',
  '3': 'April',
  '4': 'May',
  '5': 'June',
  '6': 'July',
  '7': 'August',
  '8': 'September',
  '9': 'October',
  '10': 'November',
  '11': 'December',
};
export const tosLastUpdated = parse(process.env.TOS_LAST_UPDATED);

export const get12From24 = hour => hourConvert.to12Hour(hour);

export const get24from12 = (hour, meridiem) => hourConvert.to24Hour({
  hour,
  meridiem,
});

export const getHours12 = date => {
  const { hour } = get12From24(date.getHours());
  return hour;
};

export const getMeridiem = date => {
  const { meridiem } = get12From24(date.getHours());
  return meridiem;
};

export const isPM = date => getMeridiem(date) === 'pm';

export const isSameMeridiem = (d1, d2) => isSameDay(d1, d2)
  && getMeridiem(d1) === getMeridiem(d2);

export const getDayOptions = (min, max, date) => {
  const minDay = min || 1;
  const maxDay = max || getDaysInMonth(date);
  const options = {};
  for (let i = minDay; i <= maxDay; i += 1) {
    options[i] = padStart(i, 2, '0');
  }
  return options;
};

export const getHourOptions = (min = 1, max = 12) => {
  const options = {};
  for (let i = min; i <= max; i += 1) {
    options[i] = padStart(i, 2, '0');
  }
  return options;
};

export const getMeridiemOptions = () => ({
  am: 'am',
  pm: 'pm',
});

export const getMinuteOptions = (min = 0, max = 59) => {
  const options = {};
  for (let i = min; i <= max; i += 1) {
    options[i] = padStart(i, 2, '0');
  }
  return options;
};

/* eslint-enable quote-props */
export const getMonthOptions = (min, max) => (min || max
  ? omitBy(
    months,
    (value, key) => (min && key < min)
      || (max && key > max),
  )
  : months);

export const getYearOptions = (min, max) => {
  const options = {};
  for (let i = min; i <= max; i += 1) {
    options[i] = i.toString();
  }
  return options;
};

export const getNow = fmt => format(new Date(), fmt);

export const getDateTime = () => getNow('YYYY-MM-DD HH:mm:ss');

export const getTosLastUpdate = () => format(tosLastUpdated, 'YYYY-MM-DD HH:mm:ss');

export const getUnixTime = () => getNow('X');

export const stringToDate = (str, fmt = 'YYYY-MM-DD HH:mm:ss') => format(
  Date.now() + ms(str),
  fmt,
);

export const getMaxDateForAdultOnly = (enabled) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - (enabled ? ADULT_AGE : MIN_AGE));
  return date;
};
